import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// API: GET /api/v1/payment/payout-accounts/default?provider_type=nurse
export const fetchDefaultPayoutAccountReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.fetch_default_payout_account,
  async ({ provider_type = "nurse" } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getDefaultPayoutAccount}?provider_type=${provider_type}`
      );
      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      }
      return rejectWithValue(response?.data?.message || i18n.t("toast.failedToFetchPayoutAccount"));
    } catch (error) {
      // A missing default account is not a hard error - just return null.
      return rejectWithValue(error?.response?.data?.message || i18n.t("toast.failedToFetchPayoutAccount"));
    }
  }
);
